import { ActionModal, FormError } from '@kcftech/design-system';
import { Label } from 'components/forms/Label';
import { TextInput } from 'components/forms/TextInput';
import { useState } from 'react';
import { formatPhoneNumber } from 'utils/phonenumber';

export type PhoneNumberConfirmModalProps = Readonly<{
    phoneNumber: string;
    onConfirm: (confirmationCode: string) => Promise<string | undefined>;
    onCancel: () => void;
}>;

const cleanConfirmationCode = (confirmationCode: string) =>
    confirmationCode
        .replace(/[^\w-]/g, '')
        .toUpperCase()
        .slice(0, 6);

export function PhoneNumberConfirmModal({
    phoneNumber,
    onConfirm,
    onCancel,
}: PhoneNumberConfirmModalProps) {
    const [confirmationCode, setConfirmationCode] = useState('');
    const [error, setError] = useState<string>();

    const onPhoneNumberConfirm = async () => {
        setError(await onConfirm(confirmationCode));
    };

    return (
        <ActionModal
            title="Confirm Phone Number"
            onAction={() => onPhoneNumberConfirm()}
            actionable={confirmationCode.length === 6}
            closeButtonText="Cancel"
            onClose={onCancel}
            height={400}
        >
            <div className="mb-20">
                A confirmation text has been sent to
                <span className="bold ml-5">
                    {phoneNumber && formatPhoneNumber(phoneNumber)}
                </span>
                . Please enter the confirmation code below.
            </div>
            <Label label="Confirmation Code" required>
                <TextInput
                    placeholder="Enter confirmation code"
                    value={confirmationCode}
                    onChange={(event) =>
                        setConfirmationCode(cleanConfirmationCode(event.target.value))
                    }
                />
            </Label>
            <FormError message={error} />
        </ActionModal>
    );
}
